export const AnalyticsPeriod = {
  TODAY: 'TODAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR',
};

export type AnalyticsPeriod =
  (typeof AnalyticsPeriod)[keyof typeof AnalyticsPeriod];

export const AnalyticsPeriosOptions = [
  {
    label: '12 months',
    value: AnalyticsPeriod.YEAR,
  },
  {
    label: '30 days',
    value: AnalyticsPeriod.MONTH,
  },
  {
    label: '7 days',
    value: AnalyticsPeriod.WEEK,
  },
  {
    label: '24 hours',
    value: AnalyticsPeriod.TODAY,
  },
];

export enum AnalyticsMetric {
  SUCCESS_RATE = 'success_rate',
  ERROR_RATE = 'error_rate',
  USER_ABANDONED = 'user_abandoned',
  TOPIC_TAGS = 'topic_tags',
  MOOD_TAGS = 'mood_tags',
  SYSTEM_AVAILABILITY = 'system_availability',
  HUMAN_ESCALATION = 'human_escalation',
  MAX_CONCURRENCY = 'max_concurrency',
}

export enum MetricCardType {
  DURATION_SECONDS = 'duration_seconds',
  AVERAGE_RESPONSE_TIME_SECONDS = 'average_response_time_seconds',
  CSAT_STARS = 'csat_stars',
}

export const ClickablePieChartMetrics = [
  AnalyticsMetric.SUCCESS_RATE,
  AnalyticsMetric.ERROR_RATE,
  AnalyticsMetric.USER_ABANDONED,
  AnalyticsMetric.TOPIC_TAGS,
  AnalyticsMetric.MOOD_TAGS,
];

export const MetricsWithoutChartButton = [
  AnalyticsMetric.SYSTEM_AVAILABILITY,
  AnalyticsMetric.TOPIC_TAGS,
  AnalyticsMetric.MOOD_TAGS,
];
